export default __webpack_public_path__ + "static/media/logo.59d51097.png";